import { useMutation } from '@tanstack/react-query'
import { postRequest } from 'utils/api/apiRequest'
import { OnSuccessApi } from 'utils/getOptionsTable'

type Data = OnSuccessApi & {
  survey: number
  answers: Record<string, string | string[]>
}

export const usePostSubmitAnswers = () => {
  return useMutation({
    mutationFn: (data: Data) => postRequest('/user-surveys/submit-answers', data),
    onSuccess: (_data, variables) => {
      variables?.onSuccess?.()
    },
  })
}
